import { render, staticRenderFns } from "./GammaDecayViz.vue?vue&type=template&id=4d82f80f&scoped=true"
import script from "./GammaDecayViz.vue?vue&type=script&lang=js"
export * from "./GammaDecayViz.vue?vue&type=script&lang=js"
import style0 from "./GammaDecayViz.vue?vue&type=style&index=0&id=4d82f80f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d82f80f",
  null
  
)

export default component.exports